// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__w8XfA","fadeIn":"Loader_fadeIn__mb3DA","spinner":"Loader_spinner__q7Ag3","spin":"Loader_spin__I7YNf","text":"Loader_text__QD0Vw"};